<template>
  <div class="hero">
    <img src="@images/heroBg.png" alt="bg">
    <div class="container">
      <div class="hero__wrapper">
        <h1 class="hero__title"><span>Marketing</span> that Moves You Forward</h1>
        <p class="hero__subtitle">Empowering brands with creative strategies, cutting-edge technology, and measurable results.</p>
        <div class="hero__buttons">
          <button class="hero__buttons-button" @click="scrollTo('contact', 'home')">Let's Talk</button>
          <button class="hero__buttons-button" @click="scrollTo('about', 'home')">Let’s get acquainted</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {scroll} from "@/core/helpers/scrollTo.js";
import {useRoute, useRouter} from "vue-router";

const router = useRouter()
const route = useRoute()

const scrollTo = (id, routeName) => {
  if (route.name === routeName) {
    scroll(id);
  } else {
    router.push({
      name: 'home'
    }).then(scroll(id, 300));
  }
}
</script>

<style lang="scss" scoped>
.hero {
  position: relative;

  & img {
    width: 100vw;
  }

  &__wrapper {
    position: absolute;
    top: 250px;
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  &__title {
    width: 550px;
    color: #2F327D;
    font-size: 44px;
    font-weight: 700;

    & span {
      color: #F48C06;
    }
  }

  &__subtitle {
    width: 500px;
    color: #464646;
    font-family: "Nunito Sans", sans-serif;
    font-size: 22px;
    font-weight: 400;
    line-height: 160%;
  }

  &__buttons {
    margin-top: 20px;
    display: flex;
    align-items: center;
    gap: 30px;

    &-button {
      cursor: pointer;
      border-radius: 80px;
      background-color: #F48C06;
      padding: 7px 20px;
      transition: 0.2s;

      color: $white;
      font-size: 18px;
      font-weight: 600;

      @include hover {
        background-color: #ff9f28;
      }

      &:last-child {
        background-color: $white;

        color: #252641;

        @include hover {
          background-color: #e0e0e0;
        }
      }
    }
  }
}

@media (max-width: 1250px) {
  .hero {
    &__wrapper {
      top: 150px;
      background-color: rgba(255, 255, 255, 0.7);
      padding: 20px;
      border-radius: 20px;
    }
  }
}

@media (max-width: 850px) {
  .hero {
    &__title {
      width: 100%;
      font-size: 32px;
    }

    &__subtitle {
      width: 100%;
      font-size: 16px;
    }

    &__wrapper {
      width: 500px;
    }
  }
}

@media (max-width: 650px) {
  .hero {
    padding-bottom: 200px;

    &__wrapper {
      top: 250px;
      width: 400px;
    }

    &__buttons {
      &-button {
        font-size: 14px;
      }
    }
  }
}

@media (max-width: 500px) {
  .hero {
    padding-bottom: 400px;

    &__wrapper {
      width: 300px;
      top: 300px;
    }

    &__title {
      font-size: 26px;
      line-height: 30px;
    }

    &__buttons {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }
  }
}

@media (max-width: 400px) {
  .hero {
    &__wrapper {
      top: 250px;
    }
  }
}
</style>